var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTicket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 468.292 468.292",
    style: {
      enableBackground: "new 0 0 468.292 468.292"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27A2DB"
    },
    d: "M124.458,366.37l-60.647,18.7c-6.591,2.032-13.581-1.663-15.613-8.254L0.775,223.012 c-2.032-6.591,1.663-13.581,8.254-15.613l60.647-18.7L124.458,366.37z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.459,
    y: 129.379,
    transform: "matrix(-0.9556 0.2946 -0.2946 -0.9556 605.2791 353.4878)",
    style: {
      fill: "#E1E6E9"
    },
    width: 345.102,
    height: 185.926
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.736,
    y: 182.437,
    transform: "matrix(0.9556 -0.2946 0.2946 0.9556 -76.5256 42.8938)",
    style: {
      fill: "#DC8744"
    },
    width: 14.692,
    height: 185.926
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#64798A"
    },
    d: "M188.651,179.877l8.545,27.714l-5.534,1.706l-8.545-27.714l-9.941,3.065l-1.562-5.066l25.416-7.837 l1.562,5.066L188.651,179.877z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#64798A"
    },
    d: "M203.034,169.895l5.534-1.706l10.107,32.78l-5.534,1.706L203.034,169.895z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#64798A"
    },
    d: "M241.183,188.533c1.906-0.588,3.449-1.412,4.627-2.478c1.178-1.065,2.301-2.534,3.367-4.402 l4.692,2.559c-2.285,4.915-5.905,8.138-10.859,9.665c-4.955,1.528-9.559,1.201-13.809-0.981c-4.25-2.181-7.127-5.711-8.631-10.589 c-1.504-4.877-1.093-9.453,1.234-13.733c2.328-4.276,6.032-7.199,11.111-8.765c5.081-1.567,9.903-1,14.468,1.701l-2.333,4.93 c-2.025-1.018-3.825-1.61-5.4-1.777c-1.574-0.165-3.299,0.041-5.175,0.62c-3.314,1.022-5.766,2.952-7.357,5.787 c-1.59,2.835-1.872,5.918-0.845,9.248c1.027,3.33,3.001,5.768,5.926,7.312C235.124,189.179,238.118,189.478,241.183,188.533z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#64798A"
    },
    d: "M252.177,154.742l5.534-1.706l4.931,15.992l10.075-20.619l7.035-2.169l-8.753,18.414l19.047,14.308 l-6.566,2.025l-15.303-10.995l-3.193,6.633l2.834,9.191l-5.534,1.706L252.177,154.742z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#64798A"
    },
    d: "M308.215,137.463l1.605,5.205l-17.492,5.393l2.675,8.676l15.71-4.844l1.518,4.923l-15.71,4.844 l2.704,8.77l18.055-5.567l1.605,5.205l-23.588,7.273l-10.107-32.78L308.215,137.463z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#64798A"
    },
    d: "M329.801,136.355l8.545,27.714l-5.534,1.706l-8.545-27.714l-9.941,3.065l-1.562-5.066l25.416-7.837 l1.562,5.066L329.801,136.355z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D5D6DB"
    },
    d: "M417.033,177.194c-65.538,19.932-131.922,40.395-197.306,60.81l-1.734-5.546 c65.407-20.417,131.802-40.88,197.349-60.824L417.033,177.194z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.656,
    y: 248.769,
    transform: "matrix(-0.9556 0.2946 -0.2946 -0.9556 398.0482 443.3776)",
    style: {
      fill: "#D5D6DB"
    },
    width: 67.934,
    height: 5.813
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313.068,
    y: 219.378,
    transform: "matrix(-0.9556 0.2946 -0.2946 -0.9556 790.3824 325.4823)",
    style: {
      fill: "#D5D6DB"
    },
    width: 115.207,
    height: 5.813
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.604,
    y: 269.197,
    transform: "matrix(-0.9556 0.2946 -0.2946 -0.9556 489.0665 470.5203)",
    style: {
      fill: "#D5D6DB"
    },
    width: 138.965,
    height: 5.813
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D5D6DB"
    },
    d: "M436.05,238.986c-59.824,17.416-120.755,36.165-181.097,55.724l-1.793-5.527 c60.403-19.575,121.387-38.343,181.265-55.775L436.05,238.986z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150.518,
    y: 309.333,
    transform: "matrix(-0.9556 0.2946 -0.2946 -0.9556 460.7489 555.0588)",
    style: {
      fill: "#D5D6DB"
    },
    width: 76.082,
    height: 5.813
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCD462"
    },
    d: "M75.952,308.627H12.488C5.591,308.627,0,303.036,0,296.139V135.19 c0-6.897,5.591-12.488,12.488-12.488h63.465V308.627z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90.661,
    y: 122.701,
    style: {
      fill: "#EBF0F3"
    },
    width: 345.1,
    height: 185.925
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75.957,
    y: 122.72,
    style: {
      fill: "#DC8744"
    },
    width: 14.692,
    height: 185.925
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#64798A"
    },
    d: "M192.246,149.328v29.001h-5.791v-29.001h-10.403v-5.301h26.597v5.301H192.246z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#64798A"
    },
    d: "M208.931,144.027h5.791v34.303h-5.791V144.027z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#64798A"
    },
    d: "M239.895,173.078c1.995,0,3.712-0.333,5.152-1.004c1.44-0.671,2.945-1.743,4.515-3.215l3.73,3.828 c-3.632,4.023-8.041,6.036-13.225,6.036c-5.186,0-9.489-1.669-12.907-5.006c-3.418-3.337-5.128-7.558-5.128-12.662 c0-5.104,1.741-9.355,5.226-12.759c3.484-3.4,7.885-5.102,13.201-5.102c5.317,0,9.758,1.963,13.324,5.888l-3.682,4.023 c-1.635-1.569-3.181-2.666-4.637-3.289c-1.456-0.621-3.165-0.933-5.128-0.933c-3.468,0-6.38,1.122-8.736,3.363 c-2.354,2.24-3.532,5.104-3.532,8.588c0,3.484,1.168,6.396,3.508,8.734C233.914,171.91,236.688,173.078,239.895,173.078z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#64798A"
    },
    d: "M260.357,144.027h5.791v16.735l15.703-16.735h7.362l-13.79,15.018l13.985,19.285h-6.871 l-11.384-15.016l-5.006,5.397v9.618h-5.791V144.027z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#64798A"
    },
    d: "M318.999,144.027v5.447h-18.304v9.079h16.439v5.152h-16.439v9.177h18.893v5.447h-24.684v-34.303 H318.999z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#64798A"
    },
    d: "M339.953,149.328v29.001h-5.791v-29.001h-10.403v-5.301h26.597v5.301H339.953z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D5D6DB"
    },
    d: "M411.279,214.057c-68.502-0.264-137.968-0.27-206.464-0.026l-0.023-5.81 c68.519-0.238,137.996-0.23,206.51,0.026L411.279,214.057z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.119,
    y: 208.249,
    style: {
      fill: "#D5D6DB"
    },
    width: 67.934,
    height: 5.813
  }), /*#__PURE__*/React.createElement("rect", {
    x: 296.086,
    y: 240.586,
    style: {
      fill: "#D5D6DB"
    },
    width: 115.206,
    height: 5.813
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.119,
    y: 240.586,
    style: {
      fill: "#D5D6DB"
    },
    width: 138.964,
    height: 5.813
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D5D6DB"
    },
    d: "M411.245,278.709c-62.3-0.984-126.05-1.021-189.476-0.111l-0.085-5.81 c63.489-0.908,127.295-0.874,189.652,0.111L411.245,278.709z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.119,
    y: 272.929,
    style: {
      fill: "#D5D6DB"
    },
    width: 76.082,
    height: 5.813
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicket);
export default __webpack_public_path__ + "static/media/ticket.bbb54f654821c9e7023b173887b59782.svg";
export { ForwardRef as ReactComponent };